module.exports = __webpack_public_path__ + "media/images/japan/schedule_arrow_1-2c120634bce0e22748fa0af7267ea007.svg";